import { Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { environment } from 'src/environments/environment';
import { TemPhieu } from 'src/app/shared/TemPhieu.model';
import { BaseService } from './Base.service';
@Injectable({
    providedIn: 'root'
})
export class TemPhieuService extends BaseService{

    DisplayColumns001: string[] = ['STT', 'ID', 'MaSo', 'URL', 'SoLanKiemTra'];
        
    List: TemPhieu[] | undefined;
    ListFilter: TemPhieu[] | undefined;
    FormData!: TemPhieu;
    

    constructor(public httpClient: HttpClient) {
        super(httpClient);
        this.Controller = "TemPhieu";
    }

    GetByQRCodeAsync() {
        let url = this.APIURL + this.Controller + '/GetByQRCodeAsync';
        const formUpload: FormData = new FormData();
        formUpload.append('data', JSON.stringify(this.BaseParameter));
        return this.httpClient.post(url, formUpload, { headers: this.Headers });
    }
    GetByURLAsync() {
        let url = this.APIURL + this.Controller + '/GetByURLAsync';
        const formUpload: FormData = new FormData();
        formUpload.append('data', JSON.stringify(this.BaseParameter));
        return this.httpClient.post(url, formUpload, { headers: this.Headers });
    }
    GetByMaSoAsync() {
        let url = this.APIURL + this.Controller + '/GetByMaSoAsync';
        const formUpload: FormData = new FormData();
        formUpload.append('data', JSON.stringify(this.BaseParameter));
        return this.httpClient.post(url, formUpload, { headers: this.Headers });
    }
    GetByMaLoHangAsync() {
        let url = this.APIURL + this.Controller + '/GetByMaLoHangAsync';
        const formUpload: FormData = new FormData();
        formUpload.append('data', JSON.stringify(this.BaseParameter));
        return this.httpClient.post(url, formUpload, { headers: this.Headers });
    }
    GetByVanChuyenGTINAsync() {
        let url = this.APIURL + this.Controller + '/GetByVanChuyenGTINAsync';
        const formUpload: FormData = new FormData();
        formUpload.append('data', JSON.stringify(this.BaseParameter));
        return this.httpClient.post(url, formUpload, { headers: this.Headers });
    }
}

